import React, { useState, useEffect } from "react";
import { Button, Typography } from "@material-tailwind/react"; // Note: Button and Typography from MTR are imported but not directly used. Consider removing if not needed.
import { Carousel, IconButton } from "@material-tailwind/react";
import {
  AiOutlineShoppingCart,
  AiOutlineHeart,
  AiOutlineCheckCircle,
} from "react-icons/ai";

// REMOVED react-toastify import
// import { toast } from "react-toastify";

// ADDED shadcn/ui toast import
import { useToast } from "@/components/hooks/use-toast"; // Adjust path if necessary

// ADDED shadcn/ui toast duration (optional, for consistency)
const SHADCN_TOAST_DURATION = 2000;

function FuturisticProductCard(props) {
  const { toast } = useToast(); // ADDED useToast hook

  const [isHovered, setIsHovered] = useState(false); // isHovered state is declared but not used. Consider removing if not needed.
  const [isFavorited, setIsFavorited] = useState(false);
  const [addedToCart, setAddedToCart] = useState(false);
  const [heartPressed, setHeartPressed] = useState(false); // heartPressed state is declared but not used. Consider removing if not needed.

  const images = [
    "https://4kwallpapers.com/images/wallpapers/macos-big-sur-apple-layers-fluidic-colorful-wwdc-stock-2048x1536-1455.jpg",
    "https://dynamicwallpaper.club/landing-vids/poster.jpg",
    "https://res.allmacwallpaper.com/get/Retina-MacBook-Air-13-inch-wallpapers/material-style-8k-2560x1600/23774-11.jpg",
    "https://wallpapers.com/images/featured/macbook-pro-n6fd0eensmrcpcsb.jpg",
    "https://512pixels.net/downloads/macos-wallpapers-6k/13-Ventura-Dark.jpg",
    "https://i.pinimg.com/originals/b3/eb/e2/b3ebe2faa2218c42fef54c80a0c9b7f0.jpg",
    "https://e0.pxfuel.com/wallpapers/766/75/desktop-wallpaper-space-colors-blue-purple-stars.jpg",
    "https://wallpapercave.com/wp/wp9139434.jpg",
    "https://wallpapercave.com/wp/wp10203505.jpg",
    "https://c4.wallpaperflare.com/wallpaper/537/926/407/dusk-mojave-california-desert-wallpaper-preview.jpg",
    "https://images.saymedia-content.com/.image/t_share/MTkyNjYzMTEwNjU3Nzc5MTI0/aesthetic-mac-wallpapers.jpg",
    "https://c4.wallpaperflare.com/wallpaper/993/722/421/3d-abstract-3d-wallpaper-preview.jpg",
    "https://i.pinimg.com/736x/9f/7a/00/9f7a0042715479838c35364624063f02.jpg",
    "https://e0.pxfuel.com/wallpapers/315/769/desktop-wallpaper-aesthetic-ideas-aesthetic-mac-space-macbook.jpg",
    "https://swall.teahub.io/photos/small/6-61671_macbook-pro-apple-wallpaper-4k.jpg",
    "https://e0.pxfuel.com/wallpapers/237/334/desktop-wallpaper-abstract-macbook-pro-default.jpg",
    "https://static.vecteezy.com/system/resources/thumbnails/022/515/452/small_2x/ai-generative3d-texture-colorful-abstract-background-for-desktop-wallpaper-image-free-photo.jpg",
    "https://img.freepik.com/photos-premium/vibrant-colorful-shapes-background_969965-10027.jpg",
    "https://e0.pxfuel.com/wallpapers/809/794/desktop-wallpaper-bejeweled-planet-and-mobile-background-1360x768.jpg",
  ];

  const handleFavoriteClick = () => {
    let text = "";
    if (isFavorited) {
      text = "Item removed from favorites"; // Corrected spelling
    } else {
      text = "Item added to favorites"; // Corrected spelling
    }

    // console.log(text); // console.log remains for debugging if needed

    // REPLACED react-toastify with shadcn/ui toast
    toast({
      title: "Favorites Update",
      description: text,
      duration: SHADCN_TOAST_DURATION,
    });

    setIsFavorited(!isFavorited);
  };

  const handleCartClick = () => {
    let text = "";
    if (addedToCart) {
      text = "Item removed from cart";
      props.addition({ name: itemName, price: itemPrice, id: props.id || itemName }, "remove"); // Added id for better item identification
    } else {
      text = "Item added to cart";
      props.addition({ name: itemName, price: itemPrice, id: props.id || itemName }, "add"); // Added id
    }

    // REPLACED react-toastify with shadcn/ui toast
    toast({
      title: "Cart Update",
      description: text,
      duration: SHADCN_TOAST_DURATION,
    });

    setAddedToCart(!addedToCart);
  };

  const generateUniqueProductName = (baseName) => {
    // This is still not truly unique across multiple card instances if they render at the same millisecond.
    // Consider passing a unique ID as a prop if true uniqueness is needed across the app.
    const randomString = Math.random().toString(36).substring(2, 7); // Made slightly longer
    return `${baseName} ${randomString}`;
  };

  // Initialize itemName once, or use a prop if available
  const [itemName, setItemName] = useState(
    () => props.name || generateUniqueProductName("Product") // Use prop name if provided
  );

  const generateRandomDecimal = () => {
    const randomDecimal = Math.random() * 99 + 1;
    return randomDecimal.toFixed(2);
  };

  const getRandomImages = (allImages, count = 4) => { // Renamed 'images' param to 'allImages' to avoid conflict
    // Fisher-Yates shuffle for better randomness and to avoid modifying original array
    const shuffled = [...allImages];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled.slice(0, count);
  }

  // Initialize randomImages once
  const [randomImages, setRandomImages] = useState(() => getRandomImages(images));
  // Initialize itemPrice once, or use a prop
  const [itemPrice, setItemPrice] = useState(() => props.price || generateRandomDecimal());
  // const [image, setImage] = useState(images[Math.floor(Math.random()*images.length)]); // This state was unused
  const [carouselHover, setCarouselHover] = useState(false);
  const [mobile, setMobile] = useState(window.innerWidth <= 500);

  const handleWindowSizeChange = () => {
    setMobile(window.innerWidth <= 500);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <div className="max-w-xs mx-auto bg-gray-50 text-white rounded-lg overflow-hidden shadow-md transform hover:scale-105 transition-transform duration-300">
      <figure className="relative h-64 w-full">
        <Carousel
          className="rounded-xl"
          onMouseEnter={() => setCarouselHover(true)}
          onMouseLeave={() => setCarouselHover(false)}
          prevArrow={({ handlePrev }) => (
            <IconButton
              variant="text"
              color="white"
              size="lg"
              onClick={handlePrev}
              className={`!absolute top-2/4 left-4 -translate-y-2/4 rounded-full ${
                carouselHover === true || mobile ? "" : "sm:invisible" // Always visible on mobile
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="white"
                className="bi bi-chevron-left" // Corrected class to className
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                />
              </svg>
            </IconButton>
          )}
          nextArrow={({ handleNext }) => (
            <IconButton
              variant="text"
              color="white"
              size="lg"
              onClick={handleNext}
              className={`!absolute top-2/4 !right-4 -translate-y-2/4 rounded-full ${
                carouselHover === true || mobile ? "" : "sm:invisible" // Always visible on mobile
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor" // Assuming white fill is desired, or set to white explicitly
                className="bi bi-chevron-right" // Corrected class to className
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                />
              </svg>
            </IconButton>
          )}
          navigation={({ setActiveIndex, activeIndex, length }) => (
            <div className="absolute bottom-4 left-2/4 z-50 flex -translate-x-2/4 gap-2">
              {new Array(length).fill("").map((_, i) => (
                <span
                  key={i}
                  className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${
                    activeIndex === i ? "w-8 bg-white" : "w-4 bg-white/50"
                  }`}
                  onClick={() => setActiveIndex(i)}
                />
              ))}
            </div>
          )}
        >
          {randomImages.map((imageUrl, index) => (
            <img
              key={index} // It's better if imageUrl is unique, or use a more stable key if available
              src={imageUrl}
              alt={`Product image ${index + 1}`} // More descriptive alt text
              className="h-full w-full object-cover"
            />
          ))}
        </Carousel>
      </figure>

      <div className="p-6">
        <h2 className="text-xl text-gray-800 font-semibold mb-2 truncate"> {/* Added truncate for long names */}
          {itemName}
        </h2>
        <p className="text-gray-800 text-sm mb-4">
          Explore the future with our cutting-edge product.
        </p>
        <div className="flex justify-between items-center">
          <span className="text-gray-800 text-base font-bold">
            ${itemPrice}
          </span>

          <div className="flex items-center gap-2 absolute top-5 right-5"> {/* This favorite button is positioned absolutely */}
            <button
              className="dwml-repo-button bg-white flex items-center justify-center w-auto p-1.5 rounded-full shadow-md hover:bg-gray-100 transition-colors" // Added some styling
              onClick={handleFavoriteClick}
              onMouseUp={() => setHeartPressed(false)} // Assuming heartPressed was for a visual effect
              title={isFavorited ? "Remove from favorites" : "Add to favorites"} // Added title for accessibility
            >
              {isFavorited ? (
                <AiOutlineHeart color="red" className="text-2xl" />
              ) : (
                <AiOutlineHeart className="text-2xl text-gray-600" /> // Default color for non-favorited
              )}
            </button>
          </div>

          <div className="flex items-center gap-2"> {/* This cart button is part of the flex row with price */}
            <button
              className={`dwml-repo-button bg-white flex items-center justify-center w-auto p-3 rounded-full shadow-md hover:bg-gray-100 transition-colors ${ // Added some styling
                addedToCart ? "added-to-cart" : "" // 'added-to-cart' class needs to be defined in your CSS if it does specific styling
              }`}
              onClick={handleCartClick}
              title={addedToCart ? "Remove from cart" : "Add to cart"} // Added title for accessibility
            >
              {addedToCart ? (
                <AiOutlineCheckCircle color="#4CAF50" size={"1.1em"} />
              ) : (
                <AiOutlineShoppingCart size={"1.1em"} className="text-gray-700" /> // Default color
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FuturisticProductCard;